import { render, staticRenderFns } from "./rechargeConfiguration.vue?vue&type=template&id=b8c23c0c&scoped=true"
import script from "./rechargeConfiguration.vue?vue&type=script&lang=js"
export * from "./rechargeConfiguration.vue?vue&type=script&lang=js"
import style0 from "./rechargeConfiguration.vue?vue&type=style&index=0&id=b8c23c0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c23c0c",
  null
  
)

export default component.exports